import React from 'react';
import { Helmet } from 'react-helmet';
import './css/globals.css';
import './css/contact.css';
import './css/header.css';
import './css/footer.css';
import './css/page.css';
import Header from './sections/Header';
import Footer from './sections/Footer';
import Banner from './sections/Banner';
import Cta from './sections/Cta';
import Section3 from './sections/Section3';
import Section4 from './sections/Section4';
import Section5 from './sections/Section5';
import Section6 from './sections/Section6';
import Section7 from './sections/Section7';
import Section8 from './sections/Section8';
import Section9 from './sections/Section9';
import Section10 from './sections/Section10';
import Section11 from './sections/Section11';
import Accordion from './sections/Accordion';

const PAGE_URL = 'https://imperialpdg.com.au/services/bathroom-kitchen-plumbing/';
const PAGE_TITLE = 'Bathroom and Kitchen Plumbing Services | Imperial PDG Gold Coast';
const PAGE_DESCRIPTION = "Discover top-tier bathroom and kitchen plumbing services with Imperial PDG, your local Bundall-based plumber on the Gold Coast.";

const WaterFilterInstallationPage = () => {

    const schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        'name': 'Imperial PDG',
        'description': 'Dependable plumbing professionals trusted by Gold Coast residents. Rely on us to resolve all your domestic and commercial plumbing issues promptly and effectively',
        'url': 'https://imperialpdg.com.au/',
        'telephone': '1300631226',
        'address': {
          '@type': 'PostalAddress',
          'addressLocality': 'Gold Coast',
          'addressRegion': 'QLD',
          'postalCode': '4217',
          'streetAddress': 'PO Box 4916',
          'addressCountry': 'AU'
        },
        'geo': {
          '@type': 'GeoCoordinates',
          'latitude': -28.01294080513038,
          'longitude': 153.40505834857066
        },
      };

  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta name="keywords" content="bathroom and kitchen plumbing gold coast, bathroom plumber gold coast, kitchen plumbing gold coast, bundall plumber" />
        <link rel="canonical" href={PAGE_URL} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:url" content={PAGE_URL} />
        <meta property="og:site_name" content="Imperial PDG" />
        <meta property="og:image" content="https://imperialpdg.com.au/img/hot-water-system-installation-gold-coast-top-banner.webp" />
        <meta property="og:locale" content="en_AU" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
        <meta name="twitter:image" content="https://imperialpdg.com.au/img/hot-water-system-installation-gold-coast-top-banner.webp" />

        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            'name': PAGE_TITLE,
            'description': PAGE_DESCRIPTION,
            'url': PAGE_URL,
            'image': {
              '@type': 'ImageObject',
              'url': 'https://imperialpdg.com.au/img/hot-water-system-installation-gold-coast-top-banner.webp',
              'width': 1200,
              'height': 630
            },
            'breadcrumb': {
              '@type': 'BreadcrumbList',
              'itemListElement': [
                { '@type': 'ListItem', 'position': 1, 'item': { '@id': 'https://imperialpdg.com.au/', 'name': 'Home' } },
                { '@type': 'ListItem', 'position': 2, 'item': { '@id': PAGE_URL, 'name': 'Bathroom and Kitchen Plumbing' } }
              ]
            }
          })}
        </script>
      </Helmet>
      <div className='waterLeaks'>
        <Header />
        <Banner 
          backgroundImg={"/img/hot-water-system-installation-gold-coast-top-banner.webp"}
          backgroundAltText={"Plumber walking with a tool bag outside"}
          title={"<b>Bathroom and Kitchen Plumbing</b>"}
          subtitle={"Expert Solutions for Your Home's Essential Spaces"}
        />
        <Cta />
        <Section9
          imgWebp={"/img/Water-Filter-Installation-Gold-Coast-second-image.webp"}
          imgJpg={"/img/Water-Filter-Installation-Gold-Coast-second-image.jpg"}
          imgAlt={"Plumber with a tool bag walking beside a hot water system"}
          title={"Your Premier Gold Coast Plumber in Bundall"}
          subtitle={"Welcome to Imperial PDG"}
          desc={"<p class='desc'>Do you need top-notch bathroom and kitchen plumbing services on the Gold Coast? Look no further than Imperial PDG, the local plumbing authority based right in Bundall. Our expert team of plumbers brings unparalleled craftsmanship, dedication, and precision to every job, ensuring your plumbing needs are met with the highest standards of quality and efficiency.</p>"}
        />
        <Section10
          imgWebp={"/img/hot-water-system-installation-gold-coast-3.webp"}
          imgJpg={"/img/hot-water-system-installation-gold-coast-3.jpg"}
          imgAlt={"Plumber with a tool bag installing a hot water system"}
          title={"Why Choose Imperial PDG?"}
          subtitle={"Bathroom & Kitchen Solutions"}
          desc={"<h6>Local Expertise</h6><p class='desc'>As a local Gold Coast plumber, we know Bundall residents' specific plumbing needs and challenges. This allows us to provide tailored solutions that work best for you.</p><h6>Comprehensive Services</h6><p class='desc'>From leaky taps in your kitchen to complete bathroom renovations, our services cover all aspects of plumbing. We ensure your water flows where it should, smoothly and efficiently.</p><h6>Quality Assurance</h6><p class='desc'>Our commitment to quality means using only the best materials and the latest techniques. We stand by our work with a satisfaction guarantee, giving you peace of mind.</p></p><h6>Customer-Centric Approach</h6><p class='desc'>At Imperial PDG, we prioritize your convenience and satisfaction. Our friendly team is always ready to listen and address your plumbing concerns promptly and effectively.</p><p class='desc'>Don't let plumbing issues dampen your day. Whether it's a minor repair or a major renovation, trust Imperial PDG to deliver exceptional results that stand the test of time. Contact us today to experience the difference of working with the finest plumbers on the Gold Coast.</p>"} 
        />
        <Section9
          imgWebp={"/img/Water-Filter-Installation-Gold-Coast-second-image.webp"}
          imgJpg={"/img/Water-Filter-Installation-Gold-Coast-second-image.jpg"}
          imgAlt={"Plumber with a tool bag walking beside a hot water system"}
          title={"Elevating Bathroom and Kitchen Plumbing on the Gold Coast"}
          subtitle={"Imperial PDG"}
          desc={"<p class='desc'>Embark on a seamless plumbing journey with Imperial PDG, the trusted local plumber of choice for Bundall and the wider Gold Coast area. Specialising in both bathroom and kitchen plumbing, our team combines technical expertise with a deep understanding of our clients' needs, ensuring every project is a resounding success.</p>"}
        />

        <Section10
          imgWebp={"/img/hot-water-system-installation-gold-coast-3.webp"}
          imgJpg={"/img/hot-water-system-installation-gold-coast-3.jpg"}
          imgAlt={"Plumber with a tool bag installing a hot water system"}
          title={"Our Promise to You"}
          subtitle={"Commitment"}
          desc={"<h6>Local Expertise</h6><p class='desc'>Being based in Bundall gives us the edge in providing prompt and reliable plumbing services tailored to the Gold Coast lifestyle.</p><h6>Versatile Solutions</h6><p class='desc'>Our extensive range of services, from quick fixes to full-scale renovations, means we're equipped to handle any plumbing challenge in your bathroom or kitchen.</p><h6>Superior Quality</h6><p class='desc'>With Imperial PDG, quality is never compromised. We use the finest materials and state-of-the-art methods to ensure durable and effective plumbing solutions.</p><p class='desc'>Only pure, filtered water from your own water supply is left for your health, safety and peace of mind.</p><h6>Unmatched Customer Service</h6><p class='desc'>We believe in building lasting relationships with our clients. Our approachable and professional team is dedicated to solving your plumbing issues with minimal fuss and maximum efficiency.</p><p class='desc'>Make the right choice for your bathroom and kitchen plumbing needs. Choose Imperial PDG for a hassle-free service that guarantees satisfaction and longevity. Contact us now for a consultation, and let us make your plumbing worries a thing of the past.</p>"}   
        />
        <Section3 />
        <Section4 />
        <Section5 />
        <Section6 />  
        <Section8 />
        <Section7 />
        <Footer />
      </div>
    </>

  )
}

export default WaterFilterInstallationPage


